module.exports = __webpack_public_path__ + "assets/img/voice-score.eb86745d.png";